// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kEiObzal5VUSAZ0YSVdR{align-items:center;display:flex}.IIDmq2WATI8SNUkxpA3N{color:var(--content-primary-secondary);font-size:13px;font-weight:400}.L7K1cqEOqlrl4bjLrIhF{color:var(--content-primary-secondary);margin-right:4px}.GIm7ZvUOXvMjjunzlPCA{color:var(--content-primary-secondary);margin-right:3px}.GIm7ZvUOXvMjjunzlPCA a[class*=mention]{background:var(--background-warning-primary);color:var(--content-warning-secondary);border-radius:6px;margin-right:-3px;padding:0 4px;font-size:13px;font-weight:400;line-height:123%;text-decoration:none}.mHfPQJrSP54cJa40mo5g{color:var(--content-negative-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `kEiObzal5VUSAZ0YSVdR`,
	"label": `IIDmq2WATI8SNUkxpA3N`,
	"icon": `L7K1cqEOqlrl4bjLrIhF`,
	"body": `GIm7ZvUOXvMjjunzlPCA`,
	"body__label": `mHfPQJrSP54cJa40mo5g`,
	"bodyLabel": `mHfPQJrSP54cJa40mo5g`
};
export default ___CSS_LOADER_EXPORT___;
